import { onBeforeUnmount, ref } from 'vue';
import { SignalRConnection, availableGroupsType } from './SignalRConnection.ts';

interface IGroup {
    groupType: availableGroupsType;
    groupId: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type CallbackType = (data?: any) => unknown;

interface IListener {
    listenerId: string;
    callBack: CallbackType;
}

interface ISignalRLifecycle {
    joinGroup: (groupType: availableGroupsType, groupId: string) => void;
    leaveGroup: (groupType: availableGroupsType, groupId: string) => void;
    listenTo: (listenerId: string, callBack: CallbackType) => void;
    endListen: (listenerId: string, callBack: CallbackType) => void;
    clearSubscriptions: () => void;
}

export const useSignalRLifecycle = (): ISignalRLifecycle => {
    const joinedGroups = ref<Array<IGroup>>([]);
    const addedListeners = ref<Array<IListener>>([]);

    onBeforeUnmount(() => {
        addedListeners.value.forEach((option) => {
            SignalRConnection.endListen(option.listenerId, option.callBack);
        });
        joinedGroups.value.forEach((option) => {
            SignalRConnection.leaveGroup(option.groupType, option.groupId);
        });
    });

    function joinGroup (groupType: availableGroupsType, groupId: string): void {
        joinedGroups.value.push({ groupType, groupId });
        SignalRConnection.joinGroup(groupType, groupId);
    }

    function leaveGroup (groupType: availableGroupsType, groupId: string): void {
        SignalRConnection.leaveGroup(groupType, groupId);
        joinedGroups.value = joinedGroups.value.filter((opt) => !(opt.groupId === groupId && opt.groupType === groupType));
    }

    function listenTo (listenerId: string, callBack: CallbackType): void {
        addedListeners.value.push({ listenerId, callBack });
        SignalRConnection.listenTo(listenerId, callBack);
    }

    function endListen (listenerId: string, callBack: CallbackType): void {
        SignalRConnection.endListen(listenerId, callBack);
        addedListeners.value = addedListeners.value.filter(
            (opt) => !(opt.listenerId === listenerId && opt.callBack === callBack),
        );
    }

    function clearSubscriptions (): void {
        addedListeners.value.forEach((option) => {
            SignalRConnection.endListen(option.listenerId, option.callBack);
        });
        joinedGroups.value.forEach((option) => {
            SignalRConnection.leaveGroup(option.groupType, option.groupId);
        });
        addedListeners.value = [];
        joinedGroups.value = [];
    }

    return {
        joinGroup,
        leaveGroup,
        listenTo,
        endListen,
        clearSubscriptions,
    };
};
